import { Routes } from '@angular/router';
import { AuthGuard } from 'app/guards/auth-guard';
import { RoleGuard } from 'app/guards/role-guard';

// Define routes specific to the admin role
export const adminRoutes: Routes = [
  {
    path: 'dashboard',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/admin/admin-dashboard/admin-dashboard').then(
        (m) => m.AdminDashboard
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'admin',
    },
  },
  // {
  //   path: 'project-management',
  //   canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
  //   loadComponent: () =>
  //     import('@pages/admin/project-management/project-management').then(
  //       (m) => m.ProjectManagement
  //     ),
  //   data: {
  //     isSidebar: 1,
  //     isHeader: 1,
  //     expectedRole: 'admin',
  //   },
  // },
  // {
  //   path: 'project-management/details/:id',
  //   canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
  //   loadComponent: () =>
  //     import(
  //       '@pages/admin/project-management/project-details/project-details'
  //     ).then((m) => m.ProjectDetails),
  //   data: {
  //     isSidebar: 1,
  //     isHeader: 1,
  //     expectedRole: 'admin',
  //   },
  // },
  {
    path: 'project-management',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/RD-Manager/project-management/project-management').then(
        (m) => m.ProjectManagement
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'Admin',
    },
  },
  {
    path: 'project-management/add-project',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import(
        '@pages/RD-Manager/project-management/add-project/add-project'
      ).then((m) => m.AddProject),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'Admin',
    },
  },
  {
    path: 'project-management/add-project/:id',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import(
        '@pages/RD-Manager/project-management/add-project/add-project'
      ).then((m) => m.AddProject),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'Admin',
    },
  },
  {
    path: 'project-management/details/:id',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import(
        '@pages/RD-Manager/project-management/project-details/project-details'
      ).then((m) => m.ProjectDetails),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'Admin',
    },
  },
  {
    path: 'user-management',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/admin/user-management/user-management').then(
        (m) => m.UserManagement
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'admin',
    },
  },
  {
    path: 'user-management/add-user',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/admin/user-management/add-user/add-user').then(
        (m) => m.AddUser
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'admin',
    },
  },
  {
    path: 'user-management/add-user/:id',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/admin/user-management/add-user/add-user').then(
        (m) => m.AddUser
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'admin',
    },
  },
  {
    path: 'user-management/bulk-onboarding',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import(
        '@pages/admin/user-management/bulk-onboarding/bulk-onboarding'
      ).then((m) => m.BulkOnboarding),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'admin',
    },
  },
  {
    path: 'resource-management',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/admin/resource-management/resource-management').then(
        (m) => m.ResourceManagement
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'admin',
    },
  },
  {
    path: 'resource-management/add-device/:id',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/admin/resource-management/add-device/add-device').then(
        (m) => m.AddDevice
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'admin',
    },
  },
  {
    path: 'resource-management/add-device',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/admin/resource-management/add-device/add-device').then(
        (m) => m.AddDevice
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'admin',
    },
  },
  {
    path: 'resource-management/device-bulk-upload',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import(
        '@pages/storekeeper/resource-management/device-bulk-upload/device-bulk-upload'
      ).then((m) => m.DeviceBulkUpload),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'admin',
    },
  },
  {
    //pass id in route
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    path: 'resource-management/device-details/:id',
    loadComponent: () =>
      import(
        '@pages/admin/resource-management/device-details/device-details'
      ).then((m) => m.DeviceDetails),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'admin',
    },
  },
];
